/**
 * Full-viewport animated gradient that sits behind app content.
 *
 * Theme-aware without JS: both light and dark gradients are declared as CSS
 * custom properties, and the `.dark` class on <html> swaps which one paints.
 * This avoids the first-paint flicker the previous JS-driven version had
 * (it defaulted to light-mode gradient until a useEffect ran and toggled it).
 */
export function AnimatedBackground() {
  return (
    <div
      aria-hidden
      className="fixed inset-0 -z-10 opacity-20 pointer-events-none animated-bg"
    />
  );
}
